import { useState, useEffect } from 'react';
import { obtenerCodigosPromocionales } from '../../../service/promocionales/CodigosPromocionales';

export const useObtenerCodigosPromocionales = (reload: number) => {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    obtenerCodigosPromocionales()
      .then((data) => {
        if (mounted) setList(data);
      })
      .catch((error) => {
        console.error('Error al obtener códigos promocionales:', error);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [reload]);

  return { list, loading };
};
